module.exports = __webpack_public_path__ + "static/media/meme_7.8facd1c9.jpg";